<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>S203群組維護-查詢條件</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>群組名稱</td>
                  <td>
                    <input
                      type="text"
                      size="40"
                      maxlength="40"
                      v-model="form.RoleName"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="doQuery()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="新增"
                          @click="btnAdd()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="清除"
                          @click="btnModalClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th colspan="2">操作</th>
                    <th>群組代碼</th>
                    <th>群組名稱</th>
                    <th>備註</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="編"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnEdit(data)"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnDelete(data)"
                      />
                    </td>
                    <td>{{ data.rolE_SEQ }}</td>
                    <td>{{ data.rolE_NAME }}</td>
                    <td>{{ data.rolE_NOTE }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <CyFooter />

    <AddModal
      v-model="addModal.show"
      :title="addModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tr>
              <td width="26%">群組名稱</td>
              <td width="74%">
                <p>
                  <input
                    type="text"
                    size="40"
                    maxlength="40"
                    v-model="addModal.form.RoleName"
                  />
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td>群組說明</td>
              <td>
                <p>
                  <input
                    type="text"
                    size="80"
                    maxlength="80"
                    v-model="addModal.form.RoleNote"
                  />
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td>權限</td>
              <td>
                <table cellpadding="0" cellspacing="0">
                  <tbody>
                    <tr>
                      <td>
                        <ul>
                          <tree-item
                            class="item"
                            :item="addModal.dropDownList"
                            @make-folder="makeFolder"
                          ></tree-item>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <p><br /></p>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="存檔"
                      @click="btnModalSave()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="btnAddModalClear()"
                    /> </span
                ></label>
              </td>
            </tr>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddModal>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex,logOut } from "@/config/util.js";
import TreeItem from "@/components/Common/TreeDirItem.vue";
import {
  S203_QueryGrid,
  S203_EditData,
  S203_RemoveData,
  S203_AddSaveData,
  S203_EditSaveData,
  S203_QueryProgOption,
} from "@/service/api.js";
export default {
  name: "S203",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        PrgName: "S203",
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        RoleName: "",
      },
      grid: [],
      addModal: {
        show: false,
        title: "S203群組維護-編輯",
        form: {
          Type: "",
          RoleSeq: "",
          RoleName: "",
          RoleNote: "",
          ProgCd: [],
        },
        grid: [],
        dropDownList: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
    AddModal: VueModal,
    TreeItem,
  },
  methods: {
    //查詢
    doQuery: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        ROLE_NAME: self.form.RoleName,
        CURRENTPAGE: 1,
        PAGESIZE: 50,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S203_QueryGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //第一頁重填
    btnModalClear: function () {
      const self = this;
      self.form.RoleName = "";
    },
    //新增
    btnAdd: function () {
      const self = this;
      sessionStorage.setItem("TreeItem", "");
      self.btnAddModalClear();
      self.getDropDownList();
      self.addModal.form.Type = "I";
      self.addModal.show = true;
    },
    btnEdit: function (data) {
      const self = this;
      self.addModal.form.Type = "U";
      self.btnAddModalClear();
      self.getDropDownList();
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        ROLE_SEQ: data.rolE_SEQ,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S203_EditData(postData).then((rData) => {
        self.addModal.grid = rData.returnObject;
        self.addModal.form.RoleSeq = rData.returnObject.rolE_SEQ;
        self.addModal.form.RoleName = rData.returnObject.rolE_NAME;
        self.addModal.form.RoleNote = rData.returnObject.rolE_NOTE;
        sessionStorage.setItem("TreeItem", String(rData.returnObject.proG_CD));
        self.addModal.show = true;
      });
    },
    btnDelete: function (data) {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        ROLE_SEQ: data.rolE_SEQ,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S203_RemoveData(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
            self.addModal.show = false;
            window.location.reload();
            //self.reload();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    getDropDownList: function () {
      const self = this;
      S203_QueryProgOption({ ServiceUnit: self.pageData.ServiceUnit }).then(
        (rData) => {
          self.addModal.dropDownList = rData.returnObject;
        }
      );
    },
    makeFolder: function (item) {
      Vue.set(item, "children", []);
      this.addItem(item);
    },
    btnModalSave: function () {
      var self = this;
      let postData = {};
      if (sessionStorage.getItem("TreeItem") == "") {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請輸入至少一個目錄"];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
          self.form.Selected = [];
          self.addModal.show = false;
        };
      }
      if (self.addModal.form.Type == "I") {
        postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          ROLE_NAME: self.addModal.form.RoleName,
          ROLE_NOTE: self.addModal.form.RoleNote,
          PROG_CD: sessionStorage.getItem("TreeItem").split(","),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁新增",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S203_AddSaveData(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["新增成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.form.Selected = [];
              self.doQuery();
              self.addModal.show = false;
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["新增失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }

      if (self.addModal.form.Type == "U") {
        postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          ROLE_SEQ: self.addModal.form.RoleSeq,
          ROLE_NAME: self.addModal.form.RoleName,
          ROLE_NOTE: self.addModal.form.RoleNote,
          PROG_CD: sessionStorage.getItem("TreeItem").split(","),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁存檔",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S203_EditSaveData(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["修改成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.form.Selected = [];
              self.doQuery();
              self.addModal.show = false;
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["修改失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    btnAddModalClear: function () {
      var self = this;
      self.addModal.form.RoleSeq = "";
      self.addModal.form.RoleName = "";
      self.addModal.form.RoleNote = "";
      self.addModal.form.ProgCd = [];
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.doQuery();
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
